<template>
  <v-card style="height: 100%">
    <v-card-title>
      <strong>Review this completion</strong>
    </v-card-title>

    <v-card-text>
      <v-container>

        <v-layout row wrap class="input-container">
          <v-flex xs12 sm3 md3>
            <label for="comment">Ratings</label>
          </v-flex>
          <v-flex xs12 sm9 md9>
            <v-btn icon v-for="i in 5" :key="i" @click="rating=i">
              <v-icon class="rating" :class="{'rating-active': i <= rating}">
                star
              </v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <!-- comment -->
        <v-layout row wrap class="input-container mb-24">
          <v-flex xs12 sm3 md3>
            <label for="comment">Comment</label>
          </v-flex>
          <v-flex xs12 sm9 md9>
            <textarea
              placeholder="Please fill in your comment about this completion(required)"
              v-model="comment"
            ></textarea>
          </v-flex>
        </v-layout>

      </v-container>
    </v-card-text>

    <v-card-actions class="review-actions">
      <button class="submit-button" @click="submitReview" :disabled="disabled">
        Submit Review
      </button>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      rating: null,
      comment: null,
    };
  },
  computed: {
    disabled() {
      return !this.rating || !this.comment;
    },
  },
  methods: {
    submitReview() {
      const data = { rating: this.rating, comment: this.comment };
      this.$emit('submit', data);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/shared.scss";

.input-container {
  box-shadow: 0 2px 6px 0.5px $border-color;
  margin-top: 15px;
}

.input-container:first-child {
  margin-top: unset;
}

input:focus , textarea:focus {
  outline: none;
}

input, textarea {
  width: 100%;
}

label {
  color: $blue;
  font-family: MuseoSans-500;
  font-size: 16px;
}

.rating {
  color: $light !important;
}

.rating.rating-active {
  color: $primary-yello !important;
}

.review-actions {
  display: flex;
  justify-content: center;
}

.submit-button {
  color: white;
  font-weight: bold;
  background: $primary;
  border-radius: 32px;
  padding: 5px 15px;
  cursor: pointer;
}

.submit-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
</style>






// WEBPACK FOOTER //
// src/components/TaskCompletionReview.vue